
var sprite = require("/tmp/build_27def88f/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 30 30\" id=\"hud_error_jax_e7bf41f0ebe12d6595ac6251b5d8c25a\" ><circle fill=\"#D8B228\" cx=\"15\" cy=\"15\" r=\"14.6\"/><path fill=\"#FFF\" d=\"M14.6 16.8h.6v.7h-.6v-.7zm.1-3.7v-.4h.6v.4l-.2 3h-.3l-.1-3z\"/><path fill=\"none\" stroke=\"#FFF\" stroke-width=\".377\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\" d=\"M8.1 20.4c-.2 0-.3-.1-.2-.3l6.9-11.9c.1-.2.3-.2.4 0l6.9 11.9c.1.2 0 .3-.2.3H8.1z\"/></symbol>";
module.exports = sprite.add(image, "hud_error_jax_e7bf41f0ebe12d6595ac6251b5d8c25a");


//////////////////
// WEBPACK FOOTER
// ./src/assets/hud_error.svg
// module id = 1246
// module chunks = 1